import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.55 21.75c9.05 0 14-7.5 14-14V7.1A10.2 10.2 0 0 0 24 4.56c-.9.4-1.85.66-2.83.77a4.94 4.94 0 0 0 2.17-2.72c-.97.57-2.03.97-3.13 1.2a4.93 4.93 0 0 0-8.4 4.48A13.98 13.98 0 0 1 1.68 3.15 4.93 4.93 0 0 0 3.2 9.72a4.88 4.88 0 0 1-2.23-.61v.06a4.93 4.93 0 0 0 3.95 4.82 4.9 4.9 0 0 1-2.22.09 4.93 4.93 0 0 0 4.6 3.42A9.88 9.88 0 0 1 0 19.54a13.94 13.94 0 0 0 7.55 2.2" })
});
export default SvgTwitter;
